import React, { Component } from 'react'
import { Select, Icon } from '@tinper/next-ui'
import { isDesign, getDesignStyle, handleCStyle, getFieldId } from '../../utils/tool'
import './style/index.less'
import PrintStore from "./PrintStore";
import { reaction } from 'mobx'

export default class Print extends Component {
  state = {
    tempData: [],
    currentTemp: undefined
  }

  fieldNames = {
    label: 'templatename',
    key: 'templatecode',
    value: 'templatecode'
  }

  componentDidMount () {
    this.getTemplateList()
  }
  
  getTemplateList = () => {
    const { rootStore, renderEnv } = this.props
    if (!isDesign(renderEnv)) {
      const printStore = rootStore?.controlStore.getStore('printStore') || new PrintStore(this.props)
      rootStore?.controlStore.registerStore('printStore', printStore)
      reaction(() => printStore.tempData, (data) => {
        this.handleDefaultData(data)
      })
      
      // 首次赋值
      this.handleDefaultData(printStore.tempData)
    }
  }
  
  handleDefaultData = (data) => {
    this.setState({ tempData: data })
    if (data?.length) this.onChange(data[0].templatecode)
  }

  onChange = (value) => {
    this.setState({ currentTemp: value })
    this.props?.onChange?.(value)
  }

  render () {
    const {
      style = {}, suffixIcon = '',
      designDomAttr = {}, designDomClassName = '',
      renderEnv, placement = 'bottomLeft'
    } = this.props
    let { visible = true, cStyle = {} } = this.props
    const showStyle = { width: 120, ...style, ...cStyle };
    const { tempData, currentTemp } = this.state
    if (isDesign(renderEnv)) {
      visible = true
    }
    if (!visible) {
      return null;
    }
    return (
      <div
        className={`yb-print`}
        {...designDomAttr}
      >
        <Select
          className={`yb-print ${getDesignStyle(renderEnv)} ${designDomClassName}`}
          {...designDomAttr}
          fieldid={`${getFieldId(this.props)}`}
          style={{ ...showStyle }}
          innerStyle={showStyle}
          allowClear
          value={currentTemp}
          options={tempData}
          suffixIcon={<Icon fieldid={`${getFieldId(this.props)}-icon`} type={suffixIcon || "uf-treearrow-down"} />}
          placement={placement}
          fieldNames={this.fieldNames}
          notFoundContent={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80093', '请先新建打印模板！', undefined, {returnDom: true, placement: 'top'})}
          placeholder={lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80094', '打印模板', undefined, {returnDom: true, placement: 'top'})}
          onChange={this.onChange}
          onClear={this.onClear}
        >
        </Select>
      </div>
    )
  }
}
